<template>
  <v-list>
    <v-list-item>
      <v-list-item-title>
        <v-text-field
          v-model="search"
          label="Search"
          @keyup="onSearch"
        />
      </v-list-item-title>
    </v-list-item>
    <v-list-item class="select-all-btn">
      <v-list-item-title>
        <v-checkbox
          v-model="isSelectAllChecked"
          label="All"
          :disabled="isSelectAllDisabled"
          hide-details
          :ripple="false"
          @change="toggleSelectAll"
        />
      </v-list-item-title>
    </v-list-item>
    <v-list-item
      v-for="(item, index) in tempHeader"
      :key="index"
      class="filter-list"
    >
      <v-list-item-title>
        <v-checkbox
          id="index"
          v-model="item.selected"
          :label="`${item.heading}`"
          hide-details
          :ripple="false"
          @change="onHeaderChange(item)"
        />
      </v-list-item-title>
    </v-list-item>
    <v-list-item class="action-btn">
      <v-list-item-action>
        <v-btn
          color="primary"
          small
          :loading="isLoading"
          :disabled="isDisabled"
          @click="applySettings"
        >
          {{ $t("update_columns") }}
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "TableHeadFilters",
  props: {
    name: {
      type: String,
      default() {
        return "";
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isDisabled: false,
      isSelectAllDisabled: false,
      isShow: false,
      search: "",
      tempHeader: JSON.parse(JSON.stringify(this.items)),
      isSelectAllChecked: false,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      selectedItems: "tableHeaders/getDataHeaders",
      payloadHeaders: "tableHeaders/getPayloadHeaders",
      isLoading: "tableHeaders/getLoading",
    }),
  },
  watch: {
    "item.selected": {
      handler() {
        // Check if all items are selected
        this.isSelectAllChecked = this.tempHeader.every(item => item.selected);
      },
      deep: true, // Enables deep watching
    },
  },
  mounted() {
    this.isSelectAllChecked = this.tempHeader.every(item => item.selected);
  },
  methods: {
    toggleSelectAll() {
      this.tempHeader.forEach((item) => {
        item.selected = this.isSelectAllChecked;

        // Update the corresponding item in `this.items`
        const index = this.items.findIndex((i) => i.key === item.key);
        if (index !== -1) {
          this.items[index].selected = item.selected;
        }

        if (!this.isSelectAllChecked) {
          this.$store.commit("tableHeaders/UPDATE_DATA_HEADERS", item);
        }
      });
      this.isDisabled = !this.tempHeader.some((item) => item.selected);
    },
    onSearch() {
      if (this.search.length > 0) {
        const re = new RegExp(this.search, "gi");
        this.tempHeader = this.items.filter((r) => r.heading.match(re));
        this.isDisabled = this.tempHeader.length === 0;
        this.isSelectAllDisabled = true;
      } else {
        // Preserve `selected` state while resetting `tempHeader`
        this.tempHeader = JSON.parse(JSON.stringify(this.items));
        this.isSelectAllDisabled = false;
      }
    },
    onHeaderChange(row) {
      // Update the corresponding item in `this.items`
      const index = this.items.findIndex((item) => item.key === row.key);
      if (index !== -1) {
        this.items[index].selected = row.selected;
      }

      this.$store.commit("tableHeaders/UPDATE_DATA_HEADERS", row);
      this.isDisabled = !this.tempHeader.some((item) => item.selected);
      this.isSelectAllChecked = this.tempHeader.every((item) => item.selected);
    },
    applySettings() {
      let columns = this.tempHeader.filter((r) => r.selected).map((r) => r.key);
      columns = [...new Set([...this.payloadHeaders, ...columns])];
      let params = {
        // tenant_id:
        // this.$route.query.tenant_id ?? this.authUser.tenant_id,
        // dt_name: this.$route.name,
        dt_name: "telematic_details",
        columns: columns,
      };

      if (this.authUser.isAdmin) {
        params.tenant_id =
          this.$route.query.fleetId || this.$route.query.tenant_id;
      } else {
        params.tenant_id = this.authUser.tenant_id;
      }

      this.$store.dispatch("tableHeaders/update", params).then(() => {
        this.$store.dispatch("alerts/success", this.$t("updated_successfully"));
        this.$emit("addColumns");
        this.isShow = false;
      });
    },
  },
};
</script>
<style lang="sass" scoped>

.v-menu__content
  .v-list
    max-height: 300px
  .action-btn
    border-top: 1px solid lightgray
    background:  white
    position: sticky
    bottom: 0
</style>